(function () {
    'use strict';

    angular.module('itxApp.preCommon').factory('preCommonCmsConfigSvc', preCommonCmsConfigSvc);

    preCommonCmsConfigSvc.$inject = [
        '$q',
        '$http',
        'AkamaiDateSvc',
        'CommonServices',
        'preCommonTimestampSvc'
    ];

    function preCommonCmsConfigSvc(
        $q,
        $http,
        AkamaiDateSvc,
        CommonServices,
        preCommonTimestampSvc
    ) {
        var _this = this;

        _this.cmsApiPath = _getCmsApiPath();
        _this.cmsApiPathMaterialized = _getCmsApiPath() + '/materialized';
        _this.cmsConfigPath = _getCmsStaticPath() + '/config';
        _this.cmsLangPath = _getCmsStaticPath() + '/lang';
        _this.cmsContentPath = _getCmsStaticPath() + '/contents';
        _this.cmsTranslationsPath = _getCmsStaticPath() + '/translations';

        return {
            getProperty: _getProperty,
            getConfigCms: _getConfigCms,
            getCmsStaticPath: _getCmsStaticPath,
            getCmsApiPath: _getCmsApiPath,
            useCmsApi: _useCmsApi,
            getBackUrlDrafts: _getBackUrlDrafts
        };

        /*
         * Función para obtener una configuración del CMS
         */
        function _getProperty(name) {
            var deferred = $q.defer();

            if (!name) {
                deferred.reject('ERROR Tienes que enviar parametro STRING');
            } else {
                return AkamaiDateSvc.getDate().then(function (resAkamai) {
                    return _getCmsConfigObj().then(function () {
                        return _getPropertyOfJsonCache(name, resAkamai);
                    });
                });
            }

            return deferred.promise;
        }

        function _getBackUrlDrafts() {
            return 'https://axinstgeccwps1-massimodutti.central.inditex.grp/integration/cms/api';
        }

        /*
         * Función para obtener todas las configuraciones del CMS
         */
        function _getCmsConfigObj() {
            var deferred = $q.defer();

            if (inditex && inditex.iCountryCode && !_this.JsonCacheConf) {
                if (!_this.isPending) {
                    _this.isPending = true;

                    if (_useCmsApi()) {
                        // Utilizamos la API del CMS
                        _this.promise = $http
                            .get(_this.cmsApiPath + '/config/' + inditex.iCountryCode)
                            .then(function (res) {
                                _this.JsonCacheConf = res.data;
                                deferred.resolve(_this.JsonCacheConf);
                            })
                            .catch(function (err) {
                                console.error(err);
                                deferred.reject(err);
                            });
                    } else {
                        // Utilizamos ficheros JSON
                        _this.promise = $http
                            .get(
                                _this.cmsConfigPath +
                                    '/config-' +
                                    inditex.iCountryCode +
                                    '.json' +
                                    '?' +
                                    preCommonTimestampSvc.getTs()
                            )
                            .then(function (res) {
                                _this.JsonCacheConf = res.data;
                                deferred.resolve(_this.JsonCacheConf);
                            })
                            .catch(function (err) {
                                console.error(err);
                                deferred.reject(err);
                            });
                    }
                }

                return _this.promise;
            } else if (_this.JsonCacheConf) {
                deferred.resolve(_this.JsonCacheConf);
            } else {
                console.error('Estamos solicitando el Json de CMS sin tener Inditex Cargado');
                deferred.reject(
                    'Inditex no está cargado, debes esperar a que este cargado para realizar la petición'
                );
            }

            return deferred.promise;
        }

        /*
         * Función para obtener una propiedad del JSON de propiedades de CMS
         */
        function _getPropertyOfJsonCache(name, today) {
            var deferred = $q.defer();
            var found = false;
            var conf;

            var property = _.find(_this.JsonCacheConf, function (item) {
                return item.key === name;
            });

            if (!property) {
                console.error('La property no está creada: ' + name);
                deferred.reject('La property no está creada: ' + name);
            } else {
                AkamaiDateSvc.getDate()
                    .then(function (date) {
                        if (property.scheduledValues && property.scheduledValues.length > 0) {
                            var scheduleValue, from, to;
                            for (var i = 0; i < property.scheduledValues.length; i++) {
                                scheduleValue = property.scheduledValues[i];
                                from = moment(scheduleValue.fromDate);
                                to = moment(scheduleValue.toDate);
                                if (date.isBetween(from, to)) {
                                    conf = JSON.parse(scheduleValue.webApp);
                                    found = true;
                                    break;
                                }
                            }
                        }

                        if (!found && property.webApp !== '') {
                            try {
                                conf = JSON.parse(property.webApp);
                            } catch (e) {
                                conf = property.webApp;
                            }

                            found = true;
                        }

                        if (found) {
                            deferred.resolve(conf);
                        } else {
                            console.error('La property [' + name + '] no tiene valor.');
                            deferred.reject('La property [' + name + '] no tiene valor.');
                        }
                    })
                    .catch(function (err) {
                        deferred.reject('Error getting Akamai date');
                    });
            }

            return deferred.promise;
        }

        /*
         * Función para obtener la configuración de CMS
         */
        function _getConfigCms(isDraft) {
            var config = {
                //apiUrl: '',
                apiMaterializedUrl: _this.cmsApiPathMaterialized,
                assetsUrl: _getCmsStaticPath() + '/assets/',
                akamaiImageVideoManagerEnabled: true,
                //materializedEntrypoint: 'static',
                ecommerce: {
                    apiBaseUrl: CommonServices.getApiPath(),
                    brandSettings: {
                        brandId: inditex.iBrandId,
                        brandName: 'Massimo Dutti',
                        mediaPathSuffix: '1_1_16'
                    },
                    appId: inditex.iAppId,
                    catalogType: '1',
                    cmsDefaultStoreId: inditex.iStoreId,
                    cmsDefaultLanguageId: inditex.iLangId,
                    providers: {
                        cmsConfigurationsStaticBaseUrl: _this.cmsConfigPath,
                        cmsTranslationsStaticBaseUrl: _this.cmsLangPath
                    }
                },
                staticMaterializedConfig: {
                    staticMaterializedUrl: _this.cmsContentPath,
                    staticMaterializedUrlChina: _this.cmsContentPath
                },
                ignoreCredentials: true,
                breakpoints: [
                    {
                        bp: '(min-width: 1280px)',
                        name: '1280px',
                        device: ['desktop-wide']
                    },
                    {
                        bp: '(min-width: 992px)',
                        name: '992px',
                        device: ['desktop']
                    },
                    {
                        bp: '(min-width: 768px)',
                        name: '768px',
                        device: ['tablet']
                    },
                    {
                        bp: '(max-width: 767px)',
                        name: '< 768px',
                        device: ['mobile']
                    }
                ]
            };
            if (_useCmsApi() || isDraft) {
                delete config.staticMaterializedConfig;
                config.ecommerce.providers = {
                    cmsConfigurationsBaseUrl: isDraft ? _getBackUrlDrafts() + '/config' :  _getCmsApiPath() + '/config',
                    cmsTranslationsBaseUrl: isDraft? _getBackUrlDrafts() + '/translations' :  _getCmsApiPath() + '/translations'
                };
            }

            return config;
        }

        /*
         * Función para obtener la ruta del estático de CMS
         */
        function _getCmsStaticPath() {
            var path;
            switch (CommonServices.getEnvironment()) {
                case 'PRO':
                    if (inditex.iCountryCode == 'CN') {
                        path = 'https://static.massimodutti.cn/3/cms';
                    } else {
                        path = 'https://static.massimodutti.net/3/cms';
                    }
                    break;
                case 'PREPRU':
                    path = 'https://axpreeccnginx2.central.inditex.grp/13/cmsPre';
                    break;

                case 'PRELT':
                    path = 'https://axpreeccnginx2.central.inditex.grp/13/cmsPre';
                    break;

                case 'PRUSTG':
                    path =
                        'https://axpreprustgeccwpslb1-massimodutti.central.inditex.grp/13/cmsDes';

                    break;
                case 'DEVELOPMENT':
                    path = 'https://' + inditex.iProxyHostStandard + 'integration/cms/api';
                    break;
                case 'STAGE':
                    path = 'https://axineccstwcsalb1.central.inditex.grp/3/cms';
                    break;
                case 'PAAS_DES_DES_PRO':
                    path = 'https://' + inditex.iProxyHostStandard + 'integration/cms/api';
                    break;
                default:
                    console.error('CMS PATH NOT DEFINED FOR :' + window.location.hostname);
                    console.error('SETTINC PRO');
                    if (inditex.iCountryCode == 'CN') {
                        path = 'https://static.massimodutti.cn/3/cms';
                    } else {
                        path = 'https://static.massimodutti.net/3/cms';
                    }
                    break;
            }

            return path;
        }

        /*
         * Función para obtener la ruta de la API de CMS
         */
        function _getCmsApiPath() {
            var path;
            switch (CommonServices.getEnvironment()) {
                case 'PRO':
                    if (inditex.iCountryCode == 'CN') {
                        path = 'https://www.massimodutti.cn/integration/cms/api';
                    } else {
                        path = 'https://www.massimodutti.com/integration/cms/api';
                    }
                    break;
                case 'PRUSTG':
                    path = 'https://axpreprustgeccwpslb1-massimodutti.central.inditex.grp/integration/cms/api';
                    break;
                case 'PRELT':
                    ath = 'https://axpreeccnginx2.central.inditex.grp/13/cmsPre';
                    break;
                case 'PREPRU':
                    path = 'https://axpreprueccwpslb1-massimodutti.central.inditex.grp/integration/cms/api';
                    break;
                case 'STAGE':
                    path = 'https://www.massimodutti.com/integration/cms/api';
                    break;
                case 'DEVELOPMENT':
                    //path = 'https://develop-cmsctapi.axdesocp1.central.inditex.grp/api';
                    path = 'https://' + inditex.iProxyHostStandard + '/integration/cms/api';
                    break;

                default:
                    console.error('CMS PATH NOT DEFINED FOR :' + window.location.hostname);
                    console.error('SETTINC PRO');
                    if (inditex.iCountryCode == 'CN') {
                        path = 'https://www.massimodutti.cn/integration/api';
                    } else {
                        path = 'https://www.massimodutti.com/integration/api';
                    }
                    break;
            }
            return path;
        }

        /*
         * Función para configurar el uso de la API de CMS
         */
        function _useCmsApi() {
            if (CommonServices.getEnvironment() === 'STAGE') {
                return false;
            }

            //SE ACTIVA API A TODOS MENOS TOP 10
            // if (
            //     inditex.iCountryCode === 'ES' ||
            //     inditex.iCountryCode === 'RU' ||
            //     inditex.iCountryCode === 'DE' ||
            //     inditex.iCountryCode === 'GB' ||
            //     inditex.iCountryCode === 'US' ||
            //     inditex.iCountryCode === 'TR' ||
            //     inditex.iCountryCode === 'MX'
            // ) {
            //     return false;
            // } else {
            //     return true;
            // }
            return true;
        }
    }
})();
